import React, { useEffect, useState } from 'react';
import { RaceDTO } from '../../interfaces/RaceDTO';
import { AthleteDTO } from '../../interfaces/AthletesDTO';
import { ClassesDTO } from '../../interfaces/ClassesDTO';

interface Props {
  race: RaceDTO;
  athleteSelect: (ath: AthleteDTO | null) => void;
}

const BiosSearch = ({ race, athleteSelect }: Props) => {
  const [searchText, setSearchText] = useState<string>('');
  const [selectedAthlete, setSelectedAthlete] = useState<AthleteDTO | null>(null);
  const [athletes, setAthletes] = useState<AthleteDTO[]>([]);

  const searchChanged = (inp: string) => {
    if (inp === '') {
      athleteSelect(null);
      setAthletes([])
    }
    setSearchText(inp);
  };

  useEffect(() => {
    onClickSearch();
  }, [searchText]);

  const onClickSearch = () => {
    let res: AthleteDTO[] = [];
    Object.keys(race.Class).forEach((key) => {
      const classAthletes = getAthletes(race.Class[parseInt(key)]);
      res = res.concat(classAthletes);
    });
    setAthletes(res); // Update the state with the found athletes
  };

  const getAthletes = (clas: ClassesDTO): AthleteDTO[] => {
    let retObj: AthleteDTO[] = [];
    if ('1' in clas.Level) {
      const aths = clas.Level['1'].Athletes;
      Object.keys(aths).forEach((key) => {
        const athlete = aths[parseInt(key)];

        // Split the search text into words for more flexible matching
        const searchTerms = searchText.toLowerCase().split(' ').filter(term => term);

        // Check if any of the search terms match the athlete's details
        const matches = searchTerms.every(term => 
          athlete.FirstName.toLowerCase().includes(term) ||
          athlete.LastName.toLowerCase().includes(term) ||
          athlete.Club.toLowerCase().includes(term)
        );

        if (matches) {
          retObj.push(athlete);
        }
      });
    }
    return retObj;
  };

  const handleAthleteSelect = (athlete: AthleteDTO) => {
    setSelectedAthlete(athlete);
    athleteSelect(athlete);
    setAthletes([]);
    //setSearchText(`${athlete.FirstName} ${athlete.LastName} ${athlete.Club}`);
  };

  return (
    <div className="input-group" style={{ position: 'relative' }}>
      <input
        type="search"
        onChange={(e) => searchChanged(e.target.value)}
        className="form-control rounded"
        style={{
          borderBottomRightRadius: '0px',
          borderTopRightRadius: '0px',
          borderRadius: '20px',
          paddingRight: '35px',
        }}
        placeholder="Search"
        aria-label="Search"
        aria-describedby="search-addon"
        value={searchText}
      />
      <button
        onClick={() => searchChanged('')}
        type="button"
        className="btn btn-danger"
      >
        X
      </button>
      <button
        onClick={onClickSearch}
        type="button"
        className="btn btn-primary"
      >
        Search
      </button>

      {/* Listbox to display search results */}
      {searchText && athletes.length > 0 ? (
        <div
          className="list-group position-absolute mt-1"
          style={{
            width: '100%',
            maxHeight: '150px',
            overflowY: 'auto',
            background: 'white',
            border: '1px solid #ddd',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            top: '32px',
            zIndex: '9',
          }}
        >
          {athletes.length > 0 ? (
            athletes.map((athlete) => (
              <button
                key={athlete.ID} // Assuming each athlete has a unique `ID`
                className="list-group-item list-group-item-action"
                style={{ cursor: 'pointer', padding: '10px' }}
                onClick={() => handleAthleteSelect(athlete)}
              >
                {athlete.FirstName} {athlete.LastName} {athlete.Club}
              </button>
            ))
          ) : (
            null
          )}
        </div>
      ) : null}
    </div>
  );
};

export default BiosSearch;
